import { useQuery } from '@tanstack/react-query';

import restClient from '../util/web-http-client';

export const useEngasjement = (soeknadId: string) => {
    return useQuery({
        queryKey: ['engasjementer', soeknadId],
        queryFn: () => restClient.getEngasjementer(soeknadId),
        retry: 1,
    });
};

export default useEngasjement;
